var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":Object.assign({}, _vm.data, _vm.configData),"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"resource":_vm.resource,"status-module":"idp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }